export const SARAH_FOOD_SLUG = 'integracao-sarah-crm';

export const SARAH_INCOMPATIBLE_SLUGS = [
  'integracao-whatsapp',
  'chatbot-com-inteligencia-artificial',
];

const getProductId = (product) => product?._id || product?.id;

const findProductById = (products, productId) => (
  products.find((product) => String(getProductId(product)) === String(productId))
);

export const hasSarahFoodSelected = (selectedIds, products) => (
  selectedIds.some((productId) => {
    const product = findProductById(products, productId);
    return product?.slug === SARAH_FOOD_SLUG;
  })
);

/**
 * Se Sarah Food estiver selecionado, remove WhatsApp e Chatbot da seleção.
 */
export const applySarahFoodCompatibility = (selectedIds, products) => {
  if (!hasSarahFoodSelected(selectedIds, products)) {
    return selectedIds;
  }

  return selectedIds.filter((productId) => {
    const product = findProductById(products, productId);
    return !product || !SARAH_INCOMPATIBLE_SLUGS.includes(product.slug);
  });
};

/**
 * Desabilita opções de WhatsApp/Chatbot enquanto Sarah Food estiver selecionado.
 */
export const isProductDisabledBySarah = (product, selectedIds, products) => {
  if (!product || !SARAH_INCOMPATIBLE_SLUGS.includes(product.slug)) {
    return false;
  }

  return hasSarahFoodSelected(selectedIds, products);
};

export const SARAH_FOOD_COMPATIBILITY_HELP = 'Sarah Food é incompatível com Integração WhatsApp e Chatbot com Inteligência Artificial. Esses produtos são desabilitados automaticamente enquanto Sarah Food estiver selecionado.';
